import type { WeightDistributionData } from '@/domain/cages';

/** Prefix columns the export endpoint expects, in this exact notation. */
const LOCATION_INFO_COLUMNS = ['location.name', 'location.timezone', 'cage.name'];

// TODO: Fix key naming convention — `daily_Distribution_Type_Tag` is the column
// header the export ships today, so renaming it changes the downloaded file.
interface WeightDistributionExportRow {
    date: string;
    daily_Distribution_Type_Tag: string;
    bin_from: string;
    bin_to: string;
    cnt: number;
    cntPct: number;
    skewness: number;
    kurtosis: number;
}

export interface WeightDistributionExport {
    columns: string[];
    rows: WeightDistributionExportRow[];
}

/**
 * Flattens the distribution response into one CSV row per bucket, carrying the
 * shape statistics of the row's own distribution type alongside it.
 */
export function buildWeightDistributionExport(
    weightDistributionData: WeightDistributionData[]
): WeightDistributionExport {
    const rows: WeightDistributionExportRow[] = [];

    for (const dayEntry of weightDistributionData) {
        for (const histogramItem of dayEntry.histograms) {
            const statsForType = dayEntry.data.find(
                (item) => item.dailyDistributionTypeTag === histogramItem.dailyDistributionTypeTag
            );

            rows.push({
                date: dayEntry.day,
                daily_Distribution_Type_Tag: histogramItem.dailyDistributionTypeTag,
                bin_from: `${histogramItem.bucket.from}g`,
                bin_to: `${histogramItem.bucket.to}g`,
                cnt: histogramItem.cnt,
                cntPct: histogramItem.cntPct,
                skewness: statsForType?.skewness ?? 0,
                kurtosis: statsForType?.kurtosis ?? 0,
            });
        }
    }

    const dayColumns = rows.length > 0 ? Object.keys(rows[0]) : [];

    return {
        columns: [...LOCATION_INFO_COLUMNS, ...dayColumns.map((column) => `day.${column}`)],
        rows,
    };
}
